<template>
  <div class="header" id="header">
    <router-link :to="nav[0].path" class="logo" ><img src="../assets/img/logo.png" alt=""></router-link>
    <a class="linkto" :class=" navIndex === index ? 'active' : ''" @click="routerLink(index, item.path)" v-for="(item,index) in nav" :key="index" v-text="item.title"></a>
    <div class="mainBtn1 hbutton_isi" style="transform: scale(.7);" @click="showform()">Contact Us</div>
    <el-dialog class="dialog" :visible.sync="dialogFormVisible">
      <div slot="title" class="dialog-title mainTitle1">
        <h3>Inquiry</h3>
      </div>
      <el-form :model="form">
        <el-form-item>
          <el-input v-model="form.name" autocomplete="off" placeholder="Name"></el-input>
          <el-input v-model="form.email" autocomplete="off" placeholder="E-mail"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.tel" autocomplete="off" placeholder="Phone Number"></el-input>
          <div style="display: flex;justify-content: space-between;align-items: center;width: 48.5%;">
            <el-input class="sms" v-model="form.VerifyCode" autocomplete="off" placeholder="VerifyCode"></el-input>
            <img class="smsimg" :src="smsList.imgData" alt="">
          </div>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.CnN" autocomplete="off" placeholder="Company Name"></el-input>
          <el-input v-model="form.CnR" autocomplete="off" placeholder="Country/Region"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="textarea" v-model="form.message" cols="30" rows="10" placeholder="Message"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="hbutton_isi mainBtn1" @click="submit()" v-loading="loading">INQUIRY</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as $request from "../api";

export default {
  name: 'Header',
  props: {
    far_nav:Number,
  },
  data() {
    return{
      nav: [
        {title: 'Home', path: './Index'},//0
        {title: 'Product', path: './Product'},//1
        {title: 'Company', path: './Company'},//2
        {title: 'Application', path: './Application'},//3
        {title: 'Service', path: './Service'},//4
        {title: 'News', path: './News'},//5
        {title: 'Contact', path: './Contact'},//6
      ],
      navIndex: 0,
      dialogFormVisible:false,
      loading:false,
      form:{
        name: '',
        email: '',
        tel: '',
        CnN: '',
        CnR: '',
        VerifyCode: '',
        message:'',
      },
      smsList:{
        imgData:'',
        session:'',
      },
    }
  },
  watch: {
    far_nav(newvalue){
      this.navIndex=newvalue
    }
  },
  methods:{
    showform(){
      this.dialogFormVisible=true
      $request.getEnquiryCode().then(res=>{
        this.smsList=res.data
        // console.log(this.smsList)
      })
    },
    submit(){
      const is=this.formCheck(this.form,1)
      // console.log(is)
      if(is.is_ok==true){
        if(this.loading==false){
          this.loading=true
          $request.postForm2(this.form,this.smsList.session).then(res=>{
            this.loading=false
            if(res.code==200){
              this.$message({message: 'Successed!',type: 'success',offset:430,})
              setTimeout(()=>{
                this.$google()
              },2000)
            }else{
              this.$message({message: 'Failed!',type: 'error',offset:430,})
            }
          })
        }
      }else if(is.is_empty==true){
        // this.loading=false
        // this.$message.warning('The form can\'t be empty!');
        this.$message({message: 'The form can\'t be empty!',type: 'warning',offset:430,})
      }else if(is.email_ok!=true){
        this.$message({message: 'The mailbox format is incorrect!',type: 'error',offset:430,})
      }else{
        this.$message({message: 'Failed!',type: 'error',offset:430,})
      }
    },
    routerLink(index, path) {
      window.removeEventListener('scroll',()=>{})
      // 点击哪个路由就赋值给自定义的下下标
      this.navIndex = index;
      // console.log(this.navIndex)
      // 路由跳转
      this.$router.push(path)
    },
    checkRouterLocal(path) {
      // 查找当前路由下标高亮
      this.navIndex = this.nav.findIndex(item => item.path === path);
    },
  },
  mounted() {
    this.$nextTick(()=>{
      window.addEventListener('scroll',()=>{
        let tou = document.querySelector('#header');
        if(this.navIndex==0){
          tou.classList.toggle("on",window.scrollY>10);
          // 900
        }else{
          tou.classList.toggle("on",window.scrollY>10);
          // 400
        }
      })
    })
  }
}
</script>

<style lang="less" scoped>
a{cursor: pointer;}
#header{position: fixed;top: 0;left: 0;width: 100%;height: 110px;display: flex;align-items: center;padding: 0 80px 0 240px;z-index: 10000;transition: .6s;
  .logo{margin-right: 60px;}
  .linkto{color: white;font: 20px Poppins-Regular;padding: 0 35px;height: 100%;display: flex;align-items: center;
    &:hover,&.active{background: @main-c1;color: @main-c4;}
  }
  &>.mainBtn1{margin-left: 40px;}
  &.on{background: @main-c4;height: 110px;box-shadow: 0 0 5px -1px rgba(255,255,255,.5);
    //.logo img{width: 150px;}
  }
  .dialog{
    .mainTitle1{margin-bottom: 0;
      h3{padding-left: 5%;margin: 0;
        &:before{left: 0;}
      }
    }
    /deep/ .el-dialog__header{padding: 20px;
      .el-dialog__headerbtn{background: white;border-radius: 50%;padding: 10px;width: 40px;height: 40px;
        i{font-size: 24px;color: @main-c2;position: relative;top: 50%;left: 50%;transform: translate(-50%,-50%);}
      }
    }
    /deep/ .el-dialog__body{padding: 30px 40px 0;
      .el-form-item__content{display: flex;align-items: center;justify-content: space-between;
        &:before,&:after{display: none;}
        .el-input,.el-textarea{display: flex;justify-content: center;width: 48.5%;
          input,textarea{width: 100%;border: none;font: 18px Helvetica;height: 50px;background: #F5F5F5;
            &::-webkit-input-placeholder{font: 18px Poppins-Regular;color: #30475E;}
          }
          textarea{padding: 15px;resize: none;height: unset;}
          &.sms{width: 75%;justify-content: space-between;

          }
        }
        .el-textarea{width: 100%;}
        .smsimg{margin-left: 10px;height: 32px;object-fit: contain;}
      }
    }
    /deep/ .el-dialog__footer{padding:0 50px 30px;text-align: left;

    }
  }
}
</style>